import { useState, useEffect } from "react";
import axios from "axios";

/**
 * Hook to get the current user
 * @returns User object
 */
const useCurrentUser = () => {
  const [user, setUser] = useState(null);

  const redirectToLogin = () => {
    let currentPage = window.location.href;
    let host = window.location.host;

    // If current page is not login page (/), redirect
    if (currentPage != "/" && currentPage.split(host)[1] != "/") {
      window.location.href = "/";
    }
  }

  // API Request to backend container
  useEffect(() => {
    axios
      .get("/api/user", { withCredentials: true }) // Add withCredentials option
      .then((response) => {
        setUser(response.data);
      })
      .catch((error) => {
        if (error.response.status == 401) {
          redirectToLogin();
        }
      });
  }, []);

  return user;
};

export default useCurrentUser;
